import { __assign } from "tslib";
import React from 'react';
var WidgetPropsContext = React.createContext();
export var WidgetPropsProvider = WidgetPropsContext.Provider;
export function withWidgetProps(selector) {
    return function (Component) { return function (props) { return (React.createElement(WidgetPropsContext.Consumer, null, function (widgetProps) { return React.createElement(Component, __assign({}, props, selector(widgetProps))); })); }; };
}
